import { PERMISSIONS } from '@access/permissions';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-file-browser-storage',
  templateUrl: './file-browser-storage.component.html',
  styleUrls: ['./file-browser-storage.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FileBrowserStorageComponent implements OnInit {
  @Input() used: number = 0;
  @Input() total: number = 0;
  @Input() isLoading: boolean = false;
  @Input() isReadOnly: boolean = false;
  
  @Output() onUpload = new EventEmitter<void>();
  @Output() onNewFolder = new EventEmitter<void>();

  readonly permissions = PERMISSIONS;

  protected get progress(){
    const prc = Math.round(this.used / this.total * 100);
    return Number.isNaN(prc) ? 0 : prc;
  }

  constructor() { }

  ngOnInit(): void {

  }
}
